<template>
  <div :style="themableStyle" class="theme-color">
    <h3 class="subtitle is-4">Comments</h3>
    <div v-if="isLoggedIn" class="card">
      <div class="card-content">
        <create-comment @addComment="addComment" :replying="false" />
      </div>
    </div>
    <comment
      v-for="comment in comments"
      :key="comment.id"
      :comment="comment"
      :commentableOwner="commentableOwner"
      :teacher="comment.attributes.user_id === userId"
      :teacherId="userId"
      :theme="theme"
      @deleteComment="deleteComment"
      @updateComment="updateComment"
    />

    <div v-if="!comments.length && isLoggedIn" class="p-5">
      <p class="is-italic">Be the first one to comment</p>
    </div>
  </div>
</template>

<script>
import Comment from '@/components/concerns/Comments/Comment'
import CreateComment from '@/components/concerns/Comments/CreateComment'
import { mapGetters } from 'vuex'
import { themableMixin } from '@/mixins/themableMixin'

export default {
  mixins: [themableMixin],
  props: [
    'storeActionRoot',
    'actionParameter',
    'commentable',
    'commentableOwner',
    'userId',
    'theme'
  ],
  data () {
    return {
      comments: []
    }
  },
  components: {
    Comment,
    CreateComment
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn'
    }),
    themableTheme () {
      return this.theme ? this.theme.name : null
    }
  },
  created () {
    this.$store
      .dispatch(`${this.storeActionRoot}/index`, this.actionParameter)
      .then((resp) => {
        this.comments = resp.data.data
      })
      .catch((_) => {
        // TODO: Handle error
        console.log('Error')
      })
  },
  methods: {
    addComment (value) {
      this.$store
        .dispatch(`${this.storeActionRoot}/create`, {
          [this.commentable]: this.actionParameter,
          content: value
        })
        .then((resp) => {
          this.comments = resp.data.data
        })
        .catch((_) => {
          // TODO: Handle error
          console.log('Error')
        })
    },
    deleteComment (value) {
      this.$store
        .dispatch(`${this.storeActionRoot}/destroy`, {
          [this.commentable]: this.actionParameter,
          comment: value
        })
        .then((resp) => {
          this.comments = resp.data.data
        })
        .catch((_) => {
          // TODO: Handle error
          console.log('Error')
        })
    },
    updateComment ({ comment, content }) {
      this.$store
        .dispatch(`${this.storeActionRoot}/update`, {
          [this.commentable]: this.actionParameter,
          comment: comment,
          content: content
        })
        .then((resp) => {
          this.comments = resp.data.data
        })
        .catch((_) => {
          // TODO: Handle error
          console.log('Error')
        })
    }
  }
}
</script>
